/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {
    useEffect,
    useState,
} from "react";
import ProductQuantity from "../ProductQuantity/ProductQuantity";
import { useParams } from "react-router";
import { ProductData, ProductShoppingCart } from "../Cart/cart.dto";
import { toast } from "@/components/ui/use-toast";
import { useCart } from "../Cart/CartContext";
import noImageAvailable from "@/assets/images.png";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { useLanguage } from "@/components/Navbar/LanguageContext";
import {useCheckUserUM} from "@/components/utils/useCheckUserUM";
import {getDecodedTokenDetails} from "@/components/Token/TokenService";

interface ProductCardProps {
    productData: ProductData;
    horizontal?: boolean;
    autoPlayCarousel: boolean;
}

const ProductCard: React.FC<ProductCardProps> = ({ productData, horizontal, autoPlayCarousel }) => {
    const { cart, addToCart, updateCartItemQuantity } = useCart();
    const [cartItemIndex, setCartItemIndex] = useState(-1);
    const [cartQuantity, setCartQuantity] = useState<number | undefined>(undefined);
   
    useEffect(() => {
        const stockItems = cart ? cart.items.stockItems : [];
        const transitItems = cart ? cart.items.transitItems : [];

        if (cart) {
            const stockIndex = stockItems.findIndex((i) => i.articleId === productData.id);
            const transitIndex = transitItems.findIndex((i) => i.articleId === productData.id);

            const finalIndex = transitIndex !== -1 ? transitIndex : stockIndex;
            const finalQuantity = transitIndex !== -1
                ? transitItems[transitIndex].quantity
                : stockIndex !== -1
                    ? stockItems[stockIndex].quantity
                    : undefined;

            setCartItemIndex(finalIndex);
            setCartQuantity(finalQuantity);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cart?.items]);

    const [quantity, setQuantity] = useState(cartQuantity ?? 1);

    const queryParams = useParams();
    const isProductPage = queryParams.productId !== undefined;

    // Update cart
    useEffect(() => {
        if (cartItemIndex !== -1) {
            updateCartItemQuantity(productData.id, quantity, productData.isTransit);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [quantity]);

    const addToCartHandler = async (ev: React.MouseEvent<HTMLButtonElement>) => {
        ev.preventDefault();
        const newCartItem: ProductShoppingCart = {
            ...productData,
            articleId: productData.id,
            quantity,
            salesPrice: productData.salesPriceValue,
            salesUnit: productData.salesUnit,
        };

        try {
            await addToCart(newCartItem, productData.isTransit);
            toast({ description: "Produs adaugat in cos cu success" });
        } catch (error) {
            console.error("Failed to add item to cart:", error);
            toast({ description: "A aparut o eroare. Va rugam incercati din nou." });
        }
    };

    // if (props.horziontal === true)
    //   return (
    //     <ProductCardHorizontal
    //       productData={props.productData}
    //       AddToCartHandler={AddToCartHandler}
    //       cartQuantity={cartQuantity}
    //       isProductPage={isProductPage}
    //       quantityState={[quantity, SetQuantity]}
    //     />
    //   );

    // if (autoPlayCarousel)
    //     setAutoPlay(true);

    return (
        <ProductCardRender
            productData={productData}
            autoPlayCarousel={autoPlayCarousel}
            addToCartHandler={addToCartHandler}
            cartQuantity={cartQuantity}
            isProductPage={isProductPage}
            quantityState={[quantity, setQuantity]}
        />
    );
}

interface ProductCardRenderProps {
    productData: ProductData;
    autoPlayCarousel: boolean;
    isProductPage: boolean;
    cartQuantity: number | undefined;
    quantityState: [number, React.Dispatch<React.SetStateAction<number>>];
    addToCartHandler: (ev: React.MouseEvent<HTMLButtonElement>) => void;
}


const ProductCardRender: React.FC<ProductCardRenderProps> = ({
    productData,
    autoPlayCarousel,
    isProductPage,
    cartQuantity,
    quantityState,
    addToCartHandler,
}) => {
    // const {removeFromCart, updateCartItemQuantity} = useCart();
    let [quantity, setQuantity] = quantityState;
    const { language } = useLanguage();
    const [userUM, setUserUM] = useState<boolean | null>(null);
    const [atacFlowUser, setAtacFlowUser] = useState(false);

    useEffect(() => {
        (async () => {
            const tokenDetails = await getDecodedTokenDetails();

            if (tokenDetails?.token) {
                try {
                    const userAtacFlow = tokenDetails.atacFlow;
                    setAtacFlowUser(userAtacFlow);
                } catch (error) {
                    console.error('Failed to decode token', error);
                }
            } else {
                console.error('No token found');
            }
        })();
    }, []);


    useCheckUserUM((value: boolean) => setUserUM(value));

    return (
        <>
            <div
                className="group relative overflow-hidden border border-gray-100 bg-white flex-grow h-full flex flex-col">
                {/*<button*/}
                {/*    className="absolute end-4 top-4 z-10 rounded-full bg-white p-1.5 text-gray-900 transition hover:text-gray-900/75">*/}
                {/*    <span className="sr-only">Wishlist</span>*/}
                {/*    <FaRegHeart/>*/}
                {/*</button>*/}

                {/*<a*/}
                {/*    href={isProductPage ? undefined : "/product/" + productData.id}*/}
                {/*    onClick={(e) => {*/}
                {/*        if (isProductPage) {*/}
                {/*            e.preventDefault();*/}
                {/*        }*/}
                {/*    }}*/}
                {/*    className="group relative block overflow-hidden"*/}
                {/*>*/}
                <div className="flex justify-center items-center">
                    {productData.articleImage?.mainLink ? (
                            <div className="box h-40 w-40 flex items-center justify-center">
                                <div className="box">
                            {autoPlayCarousel ? <Carousel
                                useKeyboardArrows={true}
                                showThumbs={false}
                                infiniteLoop={true}
                                renderIndicator={(
                                    clickHandler: (e: React.MouseEvent | React.KeyboardEvent) => void,
                                    isSelected: boolean,
                                    index: number,
                                    label: string
                                ): React.ReactNode => (
                                    // Customize your indicator rendering logic here
                                    <button
                                        type="button"
                                        onClick={clickHandler}
                                        aria-label={label}
                                        className={isSelected ? "selected-indicator" : "indicator"}
                                    >
                                        {isSelected ?
                                            <span className="flex w-2 h-2 me-2 bg-gray-500 rounded-full"></span> :
                                            <span className="flex w-2 h-2 me-2 bg-gray-300 rounded-full"></span>}
                                    </button>
                                )}
                                autoPlay={true}
                                interval={2000}
                            >
                                {productData.articleImage?.otherLinks?.split(',').map((URL: any, index: any) => (
                                    <div className="flex justify-center items-center h-40">
                                        {URL.includes('https') ?
                                            <img alt="sample_file" src={`${URL}-80-80`} className="max-h-40 object-contain" key={index} /> :
                                            <img alt="sample_file"
                                                src={`https://auchan.vtexassets.com/arquivos/ids/${URL}-80-80`}
                                                 className="max-h-40 object-contain"
                                                key={index} />}
                                    </div>
                                ))}
                            </Carousel> : <Carousel
                                useKeyboardArrows={true}
                                showThumbs={false}
                                infiniteLoop={true}
                                verticalSwipe='natural'
                                renderIndicator={(
                                    clickHandler: (e: React.MouseEvent | React.KeyboardEvent) => void,
                                    isSelected: boolean,
                                    index: number,
                                    label: string
                                ): React.ReactNode => (
                                    // Customize your indicator rendering logic here
                                    <button
                                        type="button"
                                        onClick={clickHandler}
                                        aria-label={label}
                                        className={isSelected ? "selected-indicator" : "indicator"}
                                    >
                                        {isSelected ?
                                            <span className="flex w-2 h-2 me-2 bg-gray-500 rounded-full"></span> :
                                            <span className="flex w-2 h-2 me-2 bg-gray-300 rounded-full"></span>}
                                    </button>
                                )}
                            >
                                {productData.articleImage?.otherLinks?.split(',').map((URL: any, index: any) => (
                                    <div className="flex justify-center items-center h-40">
                                        {URL.includes('https') ?
                                            <img alt="sample_file" src={`${URL}-80-80`} className="max-h-40 object-contain" key={index} /> :
                                            <img alt="sample_file"
                                                src={`https://auchan.vtexassets.com/arquivos/ids/${URL}-80-80`}
                                                 className="max-h-40 object-contain"
                                                key={index} />}
                                    </div>
                                ))}
                            </Carousel>}
                        </div>
                            </div>
                    ) : (
                        <div className="h-40 w-40 flex items-center justify-center bg-gray-100 rounded">
                            <img
                                src={noImageAvailable}
                                alt="test"
                                //className="px-1 py-1 h-40 w-40 size-32 my-auto pb-0 object-scale-down transition mt-2 duration-500 group-hover:scale-105"
                                className=" max-h-32 object-contain"
                            />
                        </div>
                    )}
                </div>
                {/*</a>*/}

                <div className="relative bg-white py-1 px-2 flex flex-col justify-between flex-grow">
                    {!userUM && productData.isTransit ?
                        <div
                            className="group relative m-2 flex justify-center">
                            <div
                                className="h-2.5 w-2.5 rounded-full bg-yellow-500 me-2"></div>
                            <span
                                className="absolute top-4 scale-0 z-50 rounded bg-gray-800 p-2 text-xs text-white group-hover:scale-100 min-h-[3.5rem]">✨ Livrare programata</span>
                        </div> : <div
                            className="group relative m-2 flex justify-center">
                        </div>
                    }

                    <a href={isProductPage ? undefined : "/product/" + productData.id}
                       onClick={(e) => {
                           if (isProductPage) {
                               e.preventDefault();
                           }
                       }}
                       className="group relative block overflow-hidden"
                    >
                        <h3 className="mt-2 text-lg font-medium text-gray-900 min-h-[3.5rem] line-clamp-2">
                            {userUM ? (language === "romana" ? productData.displayName : (productData.longNameFR === null ? productData.displayName : productData.longNameFR)) : productData.displayName}
                        </h3>
                    </a>

                    {/*   OLD VERSION   */}
                    {!atacFlowUser && <p className="mt-1.5 text-sm text-gray-700">
                        {productData.priceWithVAT1 && productData.priceWithVAT1.toFixed(2)} RON/bucata{" "}
                        <span className="mt-1.5 text-sm text-gray-400">cu TVA</span>
                    </p>}

                    {!atacFlowUser && <p className="mt-1.5 text-sm text-gray-700">
                        {productData.unitPrice1 && productData.unitPrice1.toFixed(2)} RON
                        <span className="text-red-600">/bax</span>{" "}
                        <span className="mt-1.5 text-sm text-gray-400">fara TVA</span>
                    </p>}

                    {!atacFlowUser && <p className="mt-1.5 text-sm text-gray-700">
                        {productData.unitPriceWithVAT1 && productData.unitPriceWithVAT1.toFixed(2)} RON
                        <span className="text-red-600">/bax</span>{" "}
                        <span className="mt-1.5 text-sm text-gray-400">cu TVA</span>
                    </p>}

                    {/*<p className="mt-1.5 text-sm text-gray-700">*/}
                    {/*    {productData.priceWithVAT} RON*/}
                    {/*    <span className="text-red-600">/1 buc</span>{" "}{" "}*/}
                    {/*    <span className="mt-1.5 text-sm text-gray-400">cu TVA</span>*/}
                    {/*</p>*/}

                    {/*<p className="mt-1.5 text-sm text-gray-700">*/}
                    {/*    {productData.unitPrice} RON*/}
                    {/*    <span className="text-red-600">/5 buc</span>{" "}*/}
                    {/*    <span className="mt-1.5 text-sm text-gray-400">fara TVA</span>*/}
                    {/*</p>*/}

                    {/*<p className="mt-1.5 text-sm text-gray-700">*/}
                    {/*    {productData.unitPriceWithVAT} RON*/}
                    {/*    <span className="text-red-600">/12 buc</span>{" "}*/}
                    {/*    <span className="mt-1.5 text-sm text-gray-400">cu TVA</span>*/}
                    {/*</p>*/}

                    {/*    TABLE VERSION     */}
                    {/*<div className="w-full mr-7">*/}
                    {/*    <table className="min-w-full divide-y-2 divide-gray-200 mt-5 mb-3">*/}
                    {/*        <thead className="ltr:text-left rtl:text-right">*/}
                    {/*        <tr className="*:font-medium *:text-gray-900 border-gray-200 bg-gray-100">*/}
                    {/*            <th className="px-3 py-2 whitespace-nowrap">Cantitate produs</th>*/}
                    {/*            <th className="px-3 py-2 whitespace-nowrap">Pret pe bucata</th>*/}
                    {/*        </tr>*/}
                    {/*        </thead>*/}

                    {/*        <tbody className="divide-y divide-gray-200 *:even:bg-gray-50">*/}
                    {/*        <tr className="*:text-gray-900">*/}
                    {/*            <td className="px-3 py-2 whitespace-nowrap">1</td>*/}
                    {/*            <td className="px-3 py-2 whitespace-nowrap">8.50 RON</td>*/}
                    {/*        </tr>*/}

                    {/*        <tr className="*:text-gray-900 *:first:font-medium">*/}
                    {/*            <td className="px-3 py-2 whitespace-nowrap">5</td>*/}
                    {/*            <td className="px-3 py-2 whitespace-nowrap">7.45 RON</td>*/}
                    {/*        </tr>*/}

                    {/*        <tr className="*:text-gray-900 *:first:font-medium">*/}
                    {/*            <td className="px-3 py-2 whitespace-nowrap">8</td>*/}
                    {/*            <td className="px-3 py-2 whitespace-nowrap">6.00 RON</td>*/}
                    {/*        </tr>*/}
                    {/*        </tbody>*/}
                    {/*    </table>*/}
                    {/*</div>*/}

                    {/*     Cubes version     */}

                    {atacFlowUser && <div className="flex flex-row my-1 mx-auto gap-0.3">
                        <div className="px-0 py-0 mx-0.5 flex flex-col">
                            <span className="whitespace-nowrap">Pret {productData.multiplier} Buc</span>
                            <span className="font-bold text-xl">{productData.unitPriceWithVAT1 && productData.unitPriceWithVAT1.toFixed(2)}</span>
                        </div>
                        {productData.thresholdPrice2 &&
                            <div className="bg-orange-500 px-0.5 py-0 mx-0.5 flex flex-col text-white">
                                <span className="whitespace-nowrap">Pret +{productData.thresholdQuantity2} Buc</span>
                                <span className="font-bold text-2xl">{productData.unitPriceWithVAT2 && productData.unitPriceWithVAT2.toFixed(2)}</span>
                            </div>}
                        {productData.thresholdPrice3 && <div
                            className="bg-white-300 px-0.5 py-0 mx-0.5 flex flex-col text-orange-500 border-2 border-orange-500">
                            <span className="whitespace-nowrap">Pret +{productData.thresholdQuantity3} Buc</span>
                            <span className="font-bold text-3xl">{productData.unitPriceWithVAT3 && productData.unitPriceWithVAT3.toFixed(2)}</span>
                        </div>}
                    </div>}

                    {atacFlowUser && <div className="text-gray-400">Preturile afisate includ taxe TVA</div>}

                    <div className="flex-grow"></div>
                    {/* This takes up any extra space */}

                    <div className="pt-4">
                        <div className="flex items-center justify-center">
                            <ProductQuantity
                                quantity={quantity}
                                productMultiplier={productData.multiplier}
                                setQuantity={setQuantity}
                                productData={productData}
                            />
                        </div>
                    </div>

                    <div className="mt-auto flex">
                        {cartQuantity === undefined ? (
                            <button
                                className="block w-full mt-3 rounded bg-red-600 p-4 text-sm text-white font-medium transition hover:scale-105"
                                type="submit"
                                onClick={addToCartHandler}
                            >
                                Adauga in cos
                            </button>
                        ) : <div className="block w-full bg-gray-100 mt-3 rounded p-4 text-sm text-red-500 font-medium transition">
                            Produs adaugat in cos
                        </div>}
                    </div>
                </div>
            </div>
        </>
    );
}

export default ProductCard;
